(function () {
  var KEY = "apaRecipesReturnUrl";

  document.addEventListener("click", function (e) {
    var link = e.target.closest('[data-pdp-toggle="variety-packs"]');
    if (!link) return;
    try {
      sessionStorage.setItem(KEY, window.location.href);
    } catch (err) {}
  });

  function applyReturn() {
    var ourRecipes = document.querySelector('[data-pdp-toggle="our-recipes"]');
    if (!ourRecipes) return;
    var stored = null;
    try {
      stored = sessionStorage.getItem(KEY);
    } catch (err) {}
    if (stored) ourRecipes.setAttribute("href", stored);
  }

  if (document.readyState !== "loading") applyReturn();
  else document.addEventListener("DOMContentLoaded", applyReturn);
})();
